import React from 'react';
import CustomerTable from '../customerTable';

const LeadStatusTable: React.FC = () => {

    return (
        <div className="pt-6 bg-gray-100 rounded-lg w-full">
            <CustomerTable />
        </div>
    );
};

export default LeadStatusTable;
